"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ET = void 0;
exports.ET = {
    numericCode: '231',
    alpha2Code: 'ET',
    alpha3Code: 'ETH',
    englishName: {
        short: 'Ethiopia',
        full: 'the Federal Democratic Republic of Ethiopia',
    },
    names: {
        full: {
            en: 'the Federal Democratic Republic of Ethiopia',
            fr: "la République fédérale démocratique d'Éthiopie",
            am: "Ītyop'iya",
        },
        short: {
            en: 'Ethiopia',
            fr: "Éthiopie (l')",
            am: "Ītyop'iya",
        },
    },
    languages: [
        {
            languageAlpha2Code: 'am',
            languageAlpha3Code: 'amh',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'ET-AF': {
            numericCode: '231',
            code: 'ET-AF',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Āfar',
                en: 'Afar',
            },
        },
        'ET-AM': {
            numericCode: '231',
            code: 'ET-AM',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Āmara',
                en: 'Amara',
            },
        },
        'ET-BE': {
            numericCode: '231',
            code: 'ET-BE',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Bīnshangul Gumuz',
                en: 'Benshangul-Gumaz',
            },
        },
        'ET-GA': {
            numericCode: '231',
            code: 'ET-GA',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Gambēla Hizboch',
                en: 'Gambela Peoples',
            },
        },
        'ET-HA': {
            numericCode: '231',
            code: 'ET-HA',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Hārerī Hizb',
                en: 'Harari People',
            },
        },
        'ET-OR': {
            numericCode: '231',
            code: 'ET-OR',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Oromīya',
                en: 'Oromia',
            },
        },
        'ET-SI': {
            numericCode: '231',
            code: 'ET-SI',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Sīdama',
                en: 'Sidama',
            },
        },
        'ET-SN': {
            numericCode: '231',
            code: 'ET-SN',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'YeDebub Bihēroch Bihēreseboch na Hizboch',
                en: 'Southern Nations, Nationalities and Peoples',
            },
        },
        'ET-SO': {
            numericCode: '231',
            code: 'ET-SO',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Sumalē',
                en: 'Somali',
            },
        },
        'ET-TI': {
            numericCode: '231',
            code: 'ET-TI',
            category: {
                id: '363',
                names: {
                    am: {
                        singular: 'kilil',
                        plural: '',
                    },
                    en: {
                        singular: 'regional state',
                        plural: 'regional states',
                    },
                    fr: {
                        singular: 'État régional',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Tigray',
                en: 'Tigrai',
            },
        },
        'ET-AA': {
            numericCode: '231',
            code: 'ET-AA',
            category: {
                id: '409',
                names: {
                    am: {
                        singular: 'āstedader',
                        plural: '',
                    },
                    en: {
                        singular: 'administration',
                        plural: 'administrations',
                    },
                    fr: {
                        singular: 'administration',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Ādīs Ābeba',
                en: 'Addis Ababa',
            },
        },
        'ET-DD': {
            numericCode: '231',
            code: 'ET-DD',
            category: {
                id: '409',
                names: {
                    am: {
                        singular: 'āstedader',
                        plural: '',
                    },
                    en: {
                        singular: 'administration',
                        plural: 'administrations',
                    },
                    fr: {
                        singular: 'administration',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                am: 'Dirē Dawa',
                en: 'Dire Dawa',
            },
        },
    },
    cities: [
        {
            name: 'Ziway',
            subdivision: 'Oromiya',
        },
        {
            name: 'Yirga ‘Alem',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Yabēlo',
            subdivision: 'Oromiya',
        },
        {
            name: 'Werota',
            subdivision: 'Amhara',
        },
        {
            name: 'Wenjī',
            subdivision: 'Oromiya',
        },
        {
            name: 'Tippi',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Shashemenē',
            subdivision: 'Oromiya',
        },
        {
            name: 'Shambu',
            subdivision: 'Oromiya',
        },
        {
            name: 'Shakīso',
            subdivision: 'Oromiya',
        },
        {
            name: 'Sebeta',
            subdivision: 'Oromiya',
        },
        {
            name: 'Robīt',
            subdivision: 'Amhara',
        },
        {
            name: 'Nejo',
            subdivision: 'Oromiya',
        },
        {
            name: 'Nazrēt',
            subdivision: 'Oromiya',
        },
        {
            name: 'Mojo',
            subdivision: 'Oromiya',
        },
        {
            name: 'Metu',
            subdivision: 'Oromiya',
        },
        {
            name: 'Metahāra',
            subdivision: 'Oromiya',
        },
        {
            name: 'Mendī',
            subdivision: 'Oromiya',
        },
        {
            name: 'Mekele',
            subdivision: 'Tigray',
        },
        {
            name: 'Maych’ew',
            subdivision: 'Tigray',
        },
        {
            name: 'Korem',
            subdivision: 'Tigray',
        },
        {
            name: 'K’olīto',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Kibre Mengist',
            subdivision: 'Oromiya',
        },
        {
            name: 'Kemisē',
            subdivision: 'Amhara',
        },
        {
            name: 'Kombolcha',
            subdivision: 'Amhara',
        },
        {
            name: 'Jinka',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Jīma',
            subdivision: 'Oromiya',
        },
        {
            name: 'Jijiga',
            subdivision: 'Somali',
        },
        {
            name: 'Inda Silasē',
            subdivision: 'Tigray',
        },
        {
            name: 'Harar',
            subdivision: 'Harari',
        },
        {
            name: 'Hāgere Hiywet',
            subdivision: 'Oromiya',
        },
        {
            name: 'Gondar',
            subdivision: 'Amhara',
        },
        {
            name: 'Goba',
            subdivision: 'Oromiya',
        },
        {
            name: 'Waliso',
            subdivision: 'Oromiya',
        },
        {
            name: 'Ginir',
            subdivision: 'Oromiya',
        },
        {
            name: 'Gimbi',
            subdivision: 'Oromiya',
        },
        {
            name: 'Genet',
            subdivision: 'Oromiya',
        },
        {
            name: 'Gelemso',
            subdivision: 'Oromiya',
        },
        {
            name: 'Gebre Guracha',
            subdivision: 'Oromiya',
        },
        {
            name: 'Gambēla',
            subdivision: 'Gambela',
        },
        {
            name: 'Finote Selam',
            subdivision: 'Amhara',
        },
        {
            name: 'Fichē',
            subdivision: 'Oromiya',
        },
        {
            name: 'Felege Neway',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Dubti',
            subdivision: 'Āfar',
        },
        {
            name: 'Dodola',
            subdivision: 'Oromiya',
        },
        {
            name: 'Dire Dawa',
            subdivision: 'Dire Dawa',
        },
        {
            name: 'Dīla',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Desē',
            subdivision: 'Amhara',
        },
        {
            name: 'Dembī Dolo',
            subdivision: 'Oromiya',
        },
        {
            name: 'Bishoftu',
            subdivision: 'Oromiya',
        },
        {
            name: 'Debre Tabor',
            subdivision: 'Amhara',
        },
        {
            name: 'Debre Mark’os',
            subdivision: 'Amhara',
        },
        {
            name: 'Debre Birhan',
            subdivision: 'Amhara',
        },
        {
            name: 'Debark’',
            subdivision: 'Amhara',
        },
        {
            name: 'Butajīra',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Burē',
            subdivision: 'Amhara',
        },
        {
            name: 'Bonga',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Bodītī',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Bichena',
            subdivision: 'Amhara',
        },
        {
            name: 'Bedēsa',
            subdivision: 'Oromiya',
        },
        {
            name: 'Bedelē',
            subdivision: 'Oromiya',
        },
        {
            name: 'Batī',
            subdivision: 'Amhara',
        },
        {
            name: 'Bako',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Bahir Dar',
            subdivision: 'Amhara',
        },
        {
            name: 'Hawassa',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Āsosa',
            subdivision: 'Bīnshangul Gumuz',
        },
        {
            name: 'Āsbe Teferī',
            subdivision: 'Oromiya',
        },
        {
            name: 'Asaita',
            subdivision: 'Āfar',
        },
        {
            name: 'Āsasa',
            subdivision: 'Oromiya',
        },
        {
            name: 'Āreka',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Ārba Minch’',
            subdivision: "Southern Nations, Nationalities, and People's Region",
        },
        {
            name: 'Axum',
            subdivision: 'Tigray',
        },
        {
            name: 'Hagere Maryam',
            subdivision: 'Oromiya',
        },
        {
            name: 'Āgaro',
            subdivision: 'Oromiya',
        },
        {
            name: 'Ādīs Zemen',
            subdivision: 'Amhara',
        },
        {
            name: 'Addis Ababa',
            subdivision: 'Ādīs Ābeba',
        },
        {
            name: 'Ādīgrat',
            subdivision: 'Tigray',
        },
        {
            name: 'Addiet Canna',
            subdivision: 'Amhara',
        },
        {
            name: 'Abomsa',
            subdivision: 'Amhara',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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